


// // import React from "react";

// // const ContactDetails = ({ formData, setFormData, onNext, onBack }) => {
// //     return (
// //         <div style={cardStyle}>


// //             <div style={rowStyle}>

// //                 {/* Contact Name */}
// //                 <div style={field}>
// //                     <label style={label}>Contact Name *</label>
// //                     <input
// //                         style={input}
// //                         value={formData.contactName || ""}
// //                         onChange={(e) =>
// //                             setFormData({ ...formData, contactName: e.target.value })
// //                         }
// //                         placeholder="Enter name"
// //                     />
// //                 </div>

// //                 {/* Phone */}
// //                 <div style={field}>
// //                     <label style={label}>Phone No. *</label>
// //                     <input
// //                         style={input}
// //                         value={formData.phone || ""}
// //                         onChange={(e) =>
// //                             setFormData({ ...formData, phone: e.target.value })
// //                         }
// //                         placeholder="Enter phone number"
// //                     />
// //                 </div>

// //                 {/* Email */}
// //                 <div style={field}>
// //                     <label style={label}>Email ID *</label>
// //                     <input
// //                         style={input}
// //                         value={formData.email || ""}
// //                         onChange={(e) =>
// //                             setFormData({ ...formData, email: e.target.value })
// //                         }
// //                         placeholder="Enter email"
// //                     />
// //                 </div>

// //                 {/* Aadhar */}


// //             </div>
// //             <div style={field}>
// //                 <label style={label}>Aadhar Card No. *</label>

// //                 <div style={{
// //                     display: "flex",
// //                     gap: "12px",
// //                     alignItems: "center",
// //                     flexWrap: "wrap"
// //                 }}>

// //                     {/* Aadhar Input */}
// //                     <input
// //                         style={{ ...input, flex: "0.6", maxWidth: "366px" }}   // 👈 reduced
// //                         value={formData.aadhar || ""}
// //                         onChange={(e) =>
// //                             setFormData({ ...formData, aadhar: e.target.value })
// //                         }
// //                         placeholder="Enter Aadhar number"
// //                     />

// //                     {/* File Upload */}
// //                     <input
// //                         type="file"
// //                         style={{ ...input, flex: "0.4", padding: "6px", maxWidth: "366px" }}  // 👈 smaller
// //                         onChange={(e) => {
// //                             const file = e.target.files[0];

// //                             setFormData({
// //                                 ...formData,
// //                                 aadharFile: file,
// //                                 aadharPreview: URL.createObjectURL(file)
// //                             });
// //                         }}
// //                     />

// //                 </div>

// //                 {formData.aadharFile && (
// //                     <p style={{ fontSize: "12px", color: "green", marginTop: "5px", maxWidth: "366px" }}>
// //                         ✔ {formData.aadharFile.name}
// //                     </p>
// //                 )}
// //             </div>
// //             {/* NEXT BUTTON */}
// //             <div style={{ textAlign: "center", marginTop: "30px" }}>

// //                 <button
// //                     onClick={onBack}
// //                     style={{
// //                         background: "#6b7280",
// //                         color: "#fff",
// //                         padding: "10px 20px",
// //                         borderRadius: "8px",
// //                         border: "none",
// //                         cursor: "pointer",
// //                         marginRight: "10px"
// //                     }}
// //                 >
// //                     ← Back
// //                 </button>

// //                 <button style={nextBtn} onClick={onNext}>
// //                     Next →
// //                 </button>

// //             </div>

// //         </div>
// //     );
// // };

// // export default ContactDetails;


// // // ===== styles =====
// // const cardStyle = {
// //     background: "#fff",
// //     // padding: "24px",
// //     borderRadius: "12px",
// // };

// // const title = {
// //     fontSize: "16px",
// //     fontWeight: "600",
// //     marginBottom: "15px"
// // };

// // const rowStyle = {
// //     display: "flex",
// //     gap: "20px",
// //     flexWrap: "wrap"
// // };

// // const field = {
// //     flex: 1,
// //     minWidth: "220px"
// // };

// // const label = {
// //     fontSize: "13px",
// //     fontWeight: "600",
// //     marginBottom: "6px",
// //     display: "block"
// // };

// // const input = {
// //     width: "100%",
// //     padding: "10px",
// //     borderRadius: "8px",
// //     border: "1px solid #d1d5db",
// //     background: "#f9fafb"
// // };

// // const nextBtn = {
// //     background: "#f97316",
// //     color: "#fff",
// //     padding: "10px 30px",
// //     borderRadius: "10px",
// //     border: "none",
// //     cursor: "pointer"
// // };



// import React, { useEffect, useState } from "react";
// import { getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
// import { useLoader } from "../../../context/LoaderProvider";

// const ContactDetails = ({ formData, setFormData, onNext, onBack }) => {
//     const [loading, setLoading] = useState(false);
//     const { showLoader, hideLoader } = useLoader();

//     useEffect(() => {
//         const fetchVendorData = async () => {
//             try {
//                 showLoader();
//                 const vendorId = localStorage.getItem("vendorId");
                
//                 if (!vendorId) return;
                
//                 const data = await getEngineeringVendorById(vendorId);
                
//                 if (data && Object.keys(data).length > 0) {
//                     setFormData(prev => ({
//                         ...prev,
//                         contactName: data.holderName || "",
//                         phone: data.mobileNumber || "",
//                         email: data.email || "",
//                         aadhar: data.aadharNumber || "",
//                         aadharPreview: data.aadharPhotoFront || ""
//                     }));
//                 }
//             } catch (error) {
//                 console.error("Error fetching vendor data:", error);
//             } finally {
//                 hideLoader();
//             }
//         };
        
//         fetchVendorData();
//     }, []);

//     const handleFileUpload = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setFormData({
//                 ...formData,
//                 aadharFile: file,
//                 aadharPreview: URL.createObjectURL(file)
//             });
//         }
//     };

//     return (
//         <div style={cardStyle}>
//             <h3 style={sectionTitle}>Contact Details</h3>

//             {/* Row 1: Contact Name + Phone */}
//             <div style={rowStyle}>
//                 <div style={field}>
//                     <label style={label}>Contact Name *</label>
//                     <input
//                         style={input}
//                         value={formData.contactName || ""}
//                         onChange={(e) => setFormData({ ...formData, contactName: e.target.value })}
//                         placeholder="Enter name"
//                     />
//                 </div>

//                 <div style={field}>
//                     <label style={label}>Phone Number *</label>
//                     <input
//                         style={input}
//                         value={formData.phone || ""}
//                         onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                         placeholder="Enter phone number"
//                     />
//                 </div>
//             </div>

//             {/* Row 2: Email + Aadhaar Number */}
//             <div style={rowStyle}>
//                 <div style={field}>
//                     <label style={label}>Email *</label>
//                     <input
//                         style={input}
//                         value={formData.email || ""}
//                         onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                         placeholder="Enter email"
//                     />
//                 </div>

//                 <div style={field}>
//                     <label style={label}>Aadhaar Number</label>
//                     <input
//                         style={input}
//                         value={formData.aadhar || ""}
//                         onChange={(e) => setFormData({ ...formData, aadhar: e.target.value })}
//                         placeholder="Enter Aadhaar number"
//                     />
//                 </div>
//             </div>

//             {/* Row 3: Aadhaar Document Upload */}
//             <div style={fieldFull}>
//                 <label style={label}>Aadhaar Document</label>
                
//                 <input
//                     type="file"
//                     id="aadhar-upload"
//                     style={{ display: "none" }}
//                     onChange={handleFileUpload}
//                     accept="image/*,application/pdf"
//                 />
                
//                 <label htmlFor="aadhar-upload" style={uploadBox}>
//                     {formData.aadharPreview ? (
//                         <div style={previewContainer}>
//                             <img src={formData.aadharPreview} alt="Aadhar Preview" style={previewImage} />
//                             <span style={uploadText}>Click to change file</span>
//                         </div>
//                     ) : (
//                         <div style={uploadContent}>
//                             <div style={uploadIcon}>📄</div>
//                             <span style={uploadText}>Click to upload Aadhaar Document</span>
//                         </div>
//                     )}
//                 </label>
                
//                 {formData.aadharFile && (
//                     <p style={fileNameText}>✔ {formData.aadharFile.name}</p>
//                 )}
//             </div>

//             {/* Buttons */}
//             <div style={buttonContainer}>
//                 <button style={backBtn} onClick={onBack}>← Back</button>
//                 <button style={nextBtn} onClick={onNext}>Save & Next →</button>
//             </div>
//         </div>
//     );
// };

// export default ContactDetails;

// const cardStyle = { background: "#fff", borderRadius: "12px" };
// const sectionTitle = { fontSize: "16px", fontWeight: "600", marginBottom: "20px", color: "#111827" };
// const rowStyle = { display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "18px" };
// const field = { flex: 1, minWidth: "200px" };
// const fieldFull = { width: "100%", marginBottom: "18px" };
// const label = { fontSize: "13px", fontWeight: "600", marginBottom: "6px", display: "block", color: "#374151" };
// const input = { width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #d1d5db", background: "#f9fafb", fontSize: "13px", boxSizing: "border-box" };
// const uploadBox = { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", minHeight: "180px", border: "2px dashed #d1d5db", borderRadius: "12px", background: "#fafbfc", cursor: "pointer", transition: "0.2s", marginTop: "4px", boxSizing: "border-box" };
// const uploadContent = { display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" };
// const uploadIcon = { fontSize: "48px" };
// const uploadText = { fontSize: "14px", color: "#6b7280" };
// const previewContainer = { display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", padding: "15px" };
// const previewImage = { width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px", border: "1px solid #e5e7eb" };
// const fileNameText = { fontSize: "12px", color: "#10b981", marginTop: "8px" };
// const buttonContainer = { display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #e5e7eb" };
// const backBtn = { background: "#6b7280", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };
// const nextBtn = { background: "#f97316", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };



import React, { useEffect, useState } from "react";
import { getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
import { useLoader } from "../../../context/LoaderProvider";

const ContactDetails = ({ formData, setFormData, onNext, onBack }) => {
    const [loading, setLoading] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    // Helper function to extract filename from URL
    const getFileNameFromUrl = (url) => {
        if (!url) return null;
        try {
            const urlParts = url.split('/');
            let filename = urlParts[urlParts.length - 1];
            filename = filename.split('?')[0];
            filename = decodeURIComponent(filename);
            if (filename.length > 30) {
                filename = filename.substring(0, 27) + '...';
            }
            return filename;
        } catch (e) {
            return "Document";
        }
    };

    useEffect(() => {
        const fetchVendorData = async () => {
            try {
                showLoader();
                const vendorId = localStorage.getItem("vendorId");
                
                if (!vendorId) return;
                
                const data = await getEngineeringVendorById(vendorId);
                
                if (data && Object.keys(data).length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        contactName: data.contactName || "",
                        phone: data.contactNumber || "",
                        email: data.contactEmail || "",
                        aadhar: data.aadharNumber || "",
                        aadharPreview: data.aadharPhotoFront || ""
                    }));
                }
            } catch (error) {
                console.error("Error fetching vendor data:", error);
            } finally {
                hideLoader();
            }
        };
        
        fetchVendorData();
    }, []);

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({
                ...formData,
                aadharFile: file,
                aadharPreview: URL.createObjectURL(file)
            });
        }
    };

    const hasExistingAadhar = formData.aadharPreview && !formData.aadharFile;
    const existingFileName = hasExistingAadhar ? getFileNameFromUrl(formData.aadharPreview) : null;

    return (
        <div style={cardStyle}>
            <h3 style={sectionTitle}>Contact Details</h3>

            {/* Row 1: Contact Name + Phone */}
            <div style={rowStyle}>
                <div style={field}>
                    <label style={label}>Contact Name *</label>
                    <input
                        style={input}
                        value={formData.contactName || ""}
                        onChange={(e) => setFormData({ ...formData, contactName: e.target.value })}
                        placeholder="Enter name"
                    />
                </div>

                <div style={field}>
                    <label style={label}>Phone Number *</label>
                    <input
                        style={input}
                        value={formData.phone || ""}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        placeholder="Enter phone number"
                    />
                </div>
            </div>

            {/* Row 2: Email + Aadhaar Number */}
            <div style={rowStyle}>
                <div style={field}>
                    <label style={label}>Email *</label>
                    <input
                        style={input}
                        value={formData.email || ""}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="Enter email"
                    />
                </div>

                <div style={field}>
                    <label style={label}>Aadhaar Number</label>
                    <input
                        style={input}
                        value={formData.aadhar || ""}
                        onChange={(e) => setFormData({ ...formData, aadhar: e.target.value })}
                        placeholder="Enter Aadhaar number"
                    />
                </div>
            </div>

            {/* Row 3: Aadhaar Document Upload */}
            <div style={fieldFull}>
                <label style={label}>Aadhaar Document</label>
                
                <input
                    type="file"
                    id="aadhar-upload"
                    style={{ display: "none" }}
                    onChange={handleFileUpload}
                    accept="image/*,application/pdf"
                />
                
                <label htmlFor="aadhar-upload" style={uploadBox}>
                    {formData.aadharPreview ? (
                        <div style={filePreviewContainer}>
                            <div style={fileInfo}>
                                <span style={tickMark}>✓</span>
                                <span style={fileNameGreen}>
                                    {existingFileName || (formData.aadharFile ? formData.aadharFile.name : "Document uploaded")}
                                </span>
                            </div>
                            <span style={uploadTextSmall}>Click to change file</span>
                        </div>
                    ) : (
                        <div style={uploadContent}>
                            <div style={uploadIcon}>📄</div>
                            <span style={uploadText}>Click to upload Aadhaar Document</span>
                        </div>
                    )}
                </label>
                
                {formData.aadharFile && !hasExistingAadhar && (
                    <p style={fileNameText}>✔ {formData.aadharFile.name}</p>
                )}
            </div>

            {/* Buttons */}
            <div style={buttonContainer}>
                <button style={backBtn} onClick={onBack}>← Back</button>
                <button style={nextBtn} onClick={onNext}>Save & Next →</button>
            </div>
        </div>
    );
};

export default ContactDetails;

const cardStyle = { background: "#fff", borderRadius: "12px" };
const sectionTitle = { fontSize: "16px", fontWeight: "600", marginBottom: "20px", color: "#111827" };
const rowStyle = { display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "18px" };
const field = { flex: 1, minWidth: "200px" };
const fieldFull = { width: "100%", marginBottom: "18px" };
const label = { fontSize: "13px", fontWeight: "600", marginBottom: "6px", display: "block", color: "#374151" };
const input = { width: "100%", padding: "10px", borderRadius: "8px", border: "1px solid #d1d5db", background: "#f9fafb", fontSize: "13px", boxSizing: "border-box" };
const uploadBox = { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", minHeight: "100px", border: "2px dashed #d1d5db", borderRadius: "12px", background: "#fafbfc", cursor: "pointer", transition: "0.2s", marginTop: "4px", boxSizing: "border-box" };
const uploadContent = { display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "20px" };
const uploadIcon = { fontSize: "32px" };
const uploadText = { fontSize: "12px", color: "#6b7280" };
const uploadTextSmall = { fontSize: "10px", color: "#9ca3af", textAlign: "center", marginTop: "4px" };

// New styles for file display with green tick
const filePreviewContainer = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px",
    width: "100%"
};

const fileInfo = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "#f0fdf4",
    padding: "6px 12px",
    borderRadius: "8px",
    border: "1px solid #bbf7d0",
    marginBottom: "6px"
};

const tickMark = {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#22c55e"
};

const fileNameGreen = {
    fontSize: "12px",
    fontWeight: "500",
    color: "#166534",
    fontFamily: "monospace",
    wordBreak: "break-all"
};

const fileNameText = { fontSize: "12px", color: "#10b981", marginTop: "8px" };
const buttonContainer = { display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #e5e7eb" };
const backBtn = { background: "#6b7280", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };
const nextBtn = { background: "#f97316", color: "#fff", padding: "10px 24px", borderRadius: "8px", border: "none", cursor: "pointer", fontWeight: "500", fontSize: "14px" };